import { useState, useEffect } from "react";
import { formatDurationCompact } from "../lib/utils/time";

export function Timer({
  startTime,
  duration,
  urgent = false,
}: {
  startTime: string;
  duration?: number;
  urgent?: boolean;
}) {
  const [elapsed, setElapsed] = useState(0);

  useEffect(() => {
    const updateElapsed = () => {
      const start = new Date(startTime).getTime();
      const newElapsed = Math.floor((Date.now() - start) / 1000);
      setElapsed(duration ? Math.max(0, duration - newElapsed) : newElapsed);
    };
    updateElapsed();
    const interval = setInterval(updateElapsed, 1000);
    return () => clearInterval(interval);
  }, [startTime, duration]);

  const tone = urgent ? "bg-duel text-ink" : "bg-ink text-gold";

  return (
    <span
      className={`inline-flex items-center rounded-lg border-2 border-ink px-2.5 py-0.5 font-mono text-lg font-bold tabular-nums tracking-wider ${tone} ${urgent ? "duel-countdown-timer" : ""}`}
    >
      {formatDurationCompact(elapsed)}
    </span>
  );
}
